// ================================
// START BOX MAIN SCRIPT (jQuery)
// ================================
(function ($) {
  $(document).ready(function () {

    let currentStep = 1;
    const totalSteps = 8;
    const $steps = $(".cus_step");
    const $paginationBtns = $(".cus_page-btn");
    const $progressFill = $(".cus_progress-fill");

    // -------------------------------
    // Helper: Show Active Step
    // -------------------------------
    function showStep(step) {
      $steps.removeClass("active").eq(step - 1).addClass("active");
      $paginationBtns.removeClass("active").eq(step - 1).addClass("active");

      const progressPercent = ((step - 1) / (totalSteps - 1)) * 100;
      $progressFill.css("width", progressPercent + "%");
    }

    // -------------------------------
    // Step Navigation (Next / Prev)
    // -------------------------------
    function nextStep() {
      const $dogInput = $("#cus_dog-name");
      const $error = $(".cus_error");

      // Step 1 validation
      if (currentStep === 1 && (!$dogInput.val() || !$dogInput.val().trim())) {
        $error.show();
        $dogInput.focus();
        return;
      } else {
        $error.hide();
      }

      if (currentStep < totalSteps) {
        currentStep++;
        showStep(currentStep);
      }
    }

    function prevStep() {
      if (currentStep > 1) {
        currentStep--;
        showStep(currentStep);
      }
    }

    // Attach events to buttons via data attributes
    $(document).on("click", "[data-action='next']", function (e) {
      e.preventDefault();
      nextStep();
    });

    $(document).on("click", "[data-action='prev']", function (e) {
      e.preventDefault();
      prevStep();
    });

    $(document).on("click", "[data-action='finish']", function (e) {
      e.preventDefault();
      alert("🎉 All steps completed!");
    });

    // Pagination buttons
    $paginationBtns.on("click", function () {
      currentStep = parseInt($(this).data("step"));
      showStep(currentStep);
    });

    // Initialize
    showStep(currentStep);

    // -------------------------------
    // DYNAMIC DOG NAME DISPLAY
    // -------------------------------
    const $dogNameInput = $("#cus_dog-name");

    function updateDogNameDisplay(name) {
      $("[data-dog-name-display]").each(function () {
        $(this).text(name || "your dog");
      });
    }

    if ($dogNameInput.length) {
      updateDogNameDisplay($dogNameInput.val());
      $dogNameInput.on("input", function () {
        updateDogNameDisplay($(this).val().trim());
      });
    }

    // -------------------------------
    // STEP 3: BREED AUTOCOMPLETE
    // -------------------------------
    const breeds = [
      "Labrador Retriever", "German Shepherd", "Golden Retriever",
      "French Bulldog", "Poodle", "Bulldog", "Beagle", "Rottweiler",
      "Yorkshire Terrier", "Boxer", "Dachshund", "Corgi"
    ];

    function enableBreedAutocomplete(inputId, listId) {
      const $input = $("#" + inputId);
      const $list = $("#" + listId);
      if (!$input.length || !$list.length) return;

      $input.on("input", function () {
        const value = $(this).val().toLowerCase().trim();
        $list.empty();

        if (!value) return $list.addClass("cus_hidden");

        const filtered = breeds.filter(breed => breed.toLowerCase().includes(value));
        if (!filtered.length) return $list.addClass("cus_hidden");

        filtered.forEach(breed => {
          const $li = $("<li>").text(breed);
          $li.on("click", function () {
            $input.val(breed);
            $list.addClass("cus_hidden");
          });
          $list.append($li);
        });

        $list.removeClass("cus_hidden");
      });

      $(document).on("click", function (e) {
        if (!$(e.target).closest($list).length && e.target !== $input[0]) {
          $list.addClass("cus_hidden");
        }
      });
    }

    enableBreedAutocomplete("cus_breed1", "cus_breed-list");
    enableBreedAutocomplete("cus_breed2", "cus_breed-list2");

    // -------------------------------
    // STEP 4: BIRTHDAY VALIDATION
    // -------------------------------
    const $birthdayInput = $("#cus_dog-birthday");
    const $birthdayError = $("#cus_dog-birthday-error");

    if ($birthdayInput.length) {
      $birthdayInput.attr("max", new Date().toISOString().split("T")[0]);
    }

    $birthdayInput.on("change", function () {
      const val = $(this).val();
      const date = new Date(val);
      const today = new Date();

      if (!val || isNaN(date.getTime()) || date > today) {
        $birthdayError.show();
      } else {
        $birthdayError.hide();
      }
    });

    // -------------------------------
    // STEP 5: ALLERGY CHECKBOX LOGIC
    // -------------------------------
    const $step5 = $("#cus_step5");
    if ($step5.length) {
      const $checkboxes = $step5.find(".cus_checkbox-multi-component-input");
      const $noneCheckbox = $("#cus_allergy-none");

      $checkboxes.on("change", function () {
        if (this === $noneCheckbox[0] && $(this).is(":checked")) {
          $checkboxes.not($noneCheckbox).prop("checked", false);
        } else if (this !== $noneCheckbox[0] && $(this).is(":checked")) {
          $noneCheckbox.prop("checked", false);
        }
      });
    }

  }); // end document ready
})(jQuery);
